<app-scroll-top></app-scroll-top>
<div class="concessionaire-page min-h-50" xmlns="http://www.w3.org/1999/html">
  <div class="slider-bg-img gradient01 ">
    <div class="container">
      <nav class="py-4">
        <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
          <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
            <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
          <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Nos concessions</span></li>
        </ol>
      </nav>
      <div class="row row-cols-md-2 row-cols-sm-1 ">
        <div class="slider-txt py-md-5 py-sm-2">
          <div class="h-100">
            <h1 class="heading">MON <span style="color : #BADFFF"> HISTOIRE</span></h1>
            <ng-container *ngIf="article?.texte?.length > limiteTexte">
              <h6 class="description nl2br">
                {{article.texte| slice:0:limiteTexte}}<span id="collapseTexteHistoireConcessionaire" #collapse="ngbCollapse" [ngbCollapse]="!isTexteCollapsed" (ngbCollapseChange)="isTexteCollapsed = $event"
                  [horizontal]="true">{{article.texte| slice:limiteTexte:article.texte.length}}</span>
              </h6>
              <div>
                <button type="button" class="btn btn-outlined" (click)="isTexteCollapsed = ! isTexteCollapsed"
                  [attr.aria-expanded]="isTexteCollapsed" aria-controls="collapseTexteHistoireConcessionaire">
                  {{(!isTexteCollapsed) ? 'Lire la suite' : 'Masquer la suite'}}
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="article?.texte?.length <= limiteTexte">
              <h6 class="description nl2br">{{article.texte}}</h6>
            </ng-container>
          </div>
          <div>
          </div>
        </div>
        <div class="slider-img">
          <img style="border-radius: 50% 50% 0% 0%;" [src]="article?.urlimage" alt="Interieur cosi">

        </div>
      </div>
    </div>
  </div>
  <div class="concessionaire-bloc py-0 py-md-5">
    <div class="container content">
      <div class="formulaire text-start">
        <h3 class="heading">
          NOTRE <span class="bleutdm"> CONCEPT </span>
        </h3>
        <div class="row">
          <div class="col-12 col-md-8">
            <div class="py-2 mt-3 text-base">
              <p>Aujourd'hui, THE DOOR MAN est le premier réseau immobilier à proposer à tous ses clients vendeurs le libre choix entre :</p>
              <ul>
                <li><a [routerLink]="['/nos-formules-the-door-man.html']" fragment="mondat-flash">un mandat FLASH</a>, pour vendre leur bien via des enchères interactives en ligne,</li>
                <li>ou <a [routerLink]="['/nos-formules-the-door-man.html']" fragment="mondat-premium">un mandat PREMIUM</a>, 100 % partagé avec l’ensemble des professionnels de l’immobilier confrères présents autour du bien confié à la vente.</li>
              </ul>
              <p>Notre ambition ? <span class="fw-medium">Vendre plus vite, en plus grand nombre, et dans les meilleures conditions économiques</span>.</p>
              <p>Pour cela, nous combinons <span class="fw-medium">accompagnement humain de proximité, diffusion massive</span> des annonces, et <span class="fw-medium">innovations digitales</span> à chaque étape du parcours.</p>
              <p>En tant que <span class="fw-medium">réseau de nouvelle génération</span>, nous avons fait le choix d’outils performants, sans les lourdeurs des anciens systèmes.</p>
            </div>
          </div>
          <div class="col-12 col-md-4 align-self-center">
            <img width="425" height="236" style="    width: -webkit-fill-available; height: auto;"
              src="../../../../assets/resources/web/images/data/Schéma-Concept_Qui-sommes-nous.png"
              alt="Interieur cosi">
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="bloc-ami">
    <div class="container pb-4">
      <div class="row py-3">
        <h3 class="text-uppercase">L’<span class="bleutdm">AVENTURE</span> COMMENCE...
        </h3>
      </div>
      <div class="row row-cols-md-2 row-cols-sm-1 py-3">
        <div>
          <!--    <div class="img-bg-bloc-ami"><div class="img-bloc-ami"></div></div>-->
          <img width="651" height="537" src="assets/home/Concession.png" class="img-fluid" alt="Rencontrez nos Conseillers en immobilier">
        </div>
        <div class="align-self-md-center mt-2 mt-md-0">
          <p>
            <span class="fw-bold">Nous sommes prêts à nous investir pour vous.</span>
            THE DOOR MAN c’est
            <a class="a pe-auto" style="cursor: pointer; text-decoration: none;" (click)="onNavigateRejoindre()">
              une aventure humaine et un appel à NOUS REJOINDRE
            </a>
            également, lancé à tous les professionnels de l’immobilier
            qui partagent nos valeurs. Nos résultats sont toujours la conséquence de votre satisfaction.
            <br><br>
            <span>Je vous invite à découvrir le détail des innovations que nous avons créées pour vous, dans
              votre intérêt.<br><br>
              <span class="fw-bold"> Notre objectif : </span>être efficace pour vous servir partout en
              France. <br><br></span>
            <span>Très bonne visite de notre site.

            </span>
          </p>

        </div>
      </div>
    </div>
    <div *ngIf="personnel?.length > 0" class="bg-brand02-light py-5">
      <div class="container">
        <div class="py-4 row text-center text-uppercase text-bleu-tdm">
          <h3>notre équipe</h3>
        </div>
        <div class="row">
          <div *ngFor="let p of personnel | orderBy: 'typeid': 'asc' ; let i = index; "
            class="col-12 col-md-6 col-lg-4 p-2">
            <div class="bg-white p-3 rounded-1 shadow-sm card mb-3 text-start h-100">
              <div class="row">
                <div class="col-4">
                  <div class="position-relative rounded-circle overflow-hidden mx-auto custom-circle-image">
                    <img class=" w-100 h-100  " *ngIf="p.avatar" [src]="p.avatar" />
                    <img width="512" height="512" class=" w-100 h-100 " *ngIf="!p.avatar"
                      src="../../../../../assets/resources/web/images/data/s-personne.png" />
                  </div>
                </div>
                <!-- AMI : lien page AMI -->
                <div *ngIf="p.typeid == 6" role="button"
                  [routerLink]="['/amis-tdm','departement-'+p.departement,(p.name.replace(' ','-') ),p.id]"
                  routerLinkActive="router-link-active" class="col-8 px-2 mt-3">
                  <h5 class="text-bleu-tdm fw-bold">{{p.prenom}} {{p.nom}}</h5>
                  <div>
                    <span>{{p.fct}} (EI)</span>
                  </div>
                </div>
                <!-- Concessionnaire ou assistant (pas de Page AMI) -->
                <div *ngIf="p.typeid != 6" class="col-8 px-2 mt-3">
                  <h5 class="text-bleu-tdm fw-bold">{{p.prenom}} {{p.nom}}</h5>
                  <div>
                    <span *ngIf="p.typeid == 1">Concessionnaire</span>
                    <span *ngIf="p.typeid == 3">Assistant(e)</span>
                  </div>
                </div>
              </div>
              <div class="my-1">
                <hr>
              </div>
              <div class="px-4">
                <div *ngIf="p.rsac" class="my-2">
                  <i class="bi bi-map text-bleu-tdm me-2 "></i>
                  RSAC : {{p.rsac}}
                </div>
                <div *ngIf="p.rsac == null" class="my-2">
                  &nbsp;
                </div>
                <div *ngIf="p.ville" class="my-2"><i class="bi bi-geo-alt text-bleu-tdm me-2 "></i>
                  <span>{{p.cp}} {{p.ville}} </span>
                </div>
                <div *ngIf="p.telephone" class="my-2"><i class="bi bi-telephone text-bleu-tdm me-2 "></i>
                  <span class="text-bleu-tdm fw-bolder">{{p.telephone| phone}}</span>
                </div>
                <div>
                  <app-modal-contact [full]="'true'" [txtButton]="'ME CONTACTER'" [ami]="p"></app-modal-contact>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
